export const CONFIRM_QUESTION_TEXT = "Это ваш город?";
export const CONFIRM_BUTTON_TEXT = "Да";
export const CHANGE_BUTTON_TEXT = "Изменить";